const isExternalLink = link => {
  const trimmed = link.trim()

  return (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("mailto:")
  )
}

export default isExternalLink
